/**
 * Modal for sales representative overwrite confirmation
 */
import { showToast } from '../utils/ShowToast';

(function() {
  'use strict';

  let modalElement = null;
  let pendingData = null;

  function init() {
    modalElement = document.getElementById('overwriteSalespersonModal');
    if (!modalElement) return;

    setupNetteExtension();
    setupConfirmButton();
    setupCloseButtons();
  }

  function setupNetteExtension() {
    if (typeof $ === 'undefined' || typeof $.nette === 'undefined') return;

    $.nette.ext('overwriteModal', {
      success: function(payload) {

        if (payload.overwriteModal && payload.overwriteModal.show) {
          showModal(payload.overwriteModal);
          return;
        }

        if (payload.assignSuccess) {

          setTimeout(function() {
            hideModal();
          }, 100);

          if (payload.rowUpdates) {
            setTimeout(function() {
              updateRowsInDOM(payload.rowUpdates);
            }, 300);
          }
        }
      }
    });
  }

  /**
   * Update specific rows in the DataGrid DOM without AJAX reload
   * @param {Object} updates - Contains ids, salesPersonName, salesPersonLink
   */
  function updateRowsInDOM(updates) {
    const { ids, salesPersonName, salesPersonLink } = updates;

    ids.forEach(function(id) {
      const $row = $('tr[data-id="' + id + '"]');

      if (!$row.length) {
        return;
      }

      const $salesColumn = $row.find('td.col-salesman');

      if (!$salesColumn.length) {
        return;
      }

      if (salesPersonLink) {
        $salesColumn.html(
          '<a href="' + escapeHtml(salesPersonLink) + '">' +
          escapeHtml(salesPersonName) +
          '</a><br>'
        );
      } else {
        $salesColumn.text(salesPersonName);
      }

      $row.addClass('row-updated');
      setTimeout(function() {
        $row.removeClass('row-updated');
      }, 2000);
    });
  }

  function showModal(data) {
    if (!modalElement) {
      return;
    }

    pendingData = {
      ids: data.pendingIds,
      salesUserId: data.pendingSalesUserId
    };

    const conflictsTbody = document.getElementById('overwriteSalespersonList');
    const nonClientsTbody = document.getElementById('nonClientsSalespersonList');

    const conflictsSection = document.getElementById('overwriteSalespersonConflictsSection');
    const nonClientsSection = document.getElementById('overwriteSalespersonNonClientsSection');

    const conflictsCountEl = document.getElementById('overwriteSalespersonConflictsCount');
    const nonClientsCountEl = document.getElementById('overwriteSalespersonNonClientsCount');

    if (!conflictsTbody || !nonClientsTbody) {
      return;
    }

    // reset tables
    conflictsTbody.innerHTML = '';
    nonClientsTbody.innerHTML = '';

    const conflicts = data.items || [];
    const nonClients = data.nonClients || [];

    // update counts
    if (conflictsCountEl) {
      conflictsCountEl.textContent = conflicts.length;
    }

    if (nonClientsCountEl) {
      nonClientsCountEl.textContent = nonClients.length;
    }

    // render conflicts
    if (conflicts.length > 0) {
      if (conflictsSection) {
        conflictsSection.style.display = '';
      }

      conflicts.forEach(function (item) {
        const row = conflictsTbody.insertRow();
        row.innerHTML = `
        <td class="w-50">${escapeHtml(item.clientName)}</td>
        <td><strong>${escapeHtml(item.salesName)}</strong></td>
      `;
      });
    } else if (conflictsSection) {
      conflictsSection.style.display = 'none';
    }

    // render non-Clients
    if (nonClients.length > 0) {
      if (nonClientsSection) {
        nonClientsSection.style.display = '';
      }

      nonClients.forEach(function (item) {
        const row = nonClientsTbody.insertRow();
        row.innerHTML = `
        <td class="w-50">${escapeHtml(item.clientName)}</td>
        <td>${escapeHtml(item.accountType)}</td>
      `;
      });
    } else if (nonClientsSection) {
      nonClientsSection.style.display = 'none';
    }

    openModal();
  }

  function openModal() {
    if (!modalElement) return;

    if (typeof $ !== 'undefined' && typeof $.fn.modal !== 'undefined') {
      $(modalElement).modal('show');
      return;
    }

    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      new bootstrap.Modal(modalElement).show();
      return;
    }
  }

  function hideModal() {
    if (!modalElement) return;

    if (typeof $ !== 'undefined' && typeof $.fn.modal !== 'undefined') {
      $(modalElement).modal('hide');
    } else if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) modal.hide();
    }

    pendingData = null;
  }

  function setupCloseButtons() {
    if (!modalElement) return;

    modalElement.querySelectorAll('[data-bs-dismiss="modal"], [data-dismiss="modal"]')
      .forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          hideModal();
        });
      });

    modalElement.addEventListener('click', function(e) {
      if (e.target === modalElement) hideModal();
    });
  }

  function setupConfirmButton() {
    const confirmBtn = document.getElementById('confirmOverwriteSalespersonBtn');
    if (!confirmBtn) return;

    confirmBtn.addEventListener('click', function() {
      if (!pendingData) return;

      const btn = this;
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Processing...';

      const baseUrl = btn.getAttribute('data-confirm-link') || window.confirmOverwriteLink;

      const params = new URLSearchParams();
      pendingData.ids.forEach(function(id) {
        params.append('ids[]', id);
      });
      params.append('salesUserId', pendingData.salesUserId);
      params.append('confirm', 'true');

      $.nette.ajax({
        url: baseUrl,
        method: 'POST',
        data: params.toString(),
        contentType: 'application/x-www-form-urlencoded',
        complete: function() {
          btn.disabled = false;
          btn.innerHTML = originalText;
        },
        error: function(xhr, status, error) {
          btn.disabled = false;
          btn.innerHTML = originalText;
          showToast('error', 'Error!', 'An error occurred. Please try again.');
        }
      });
    });
  }

  jQuery.nette.ext('payloadToast', {
    success: function (payload) {
      if (payload && payload.toast) {
        showToast(payload.toast.type === 'success' ? 'success' : 'error', payload.toast.title, payload.toast.message);
      }
    }
  });

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function waitForDependencies() {
    if (typeof $ !== 'undefined' && typeof $.nette !== 'undefined') {
      init();
    } else {
      setTimeout(waitForDependencies, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForDependencies);
  } else {
    waitForDependencies();
  }
})();